// Entry point for the build script in your package.json
import './controllers'
import 'flowbite/dist/flowbite.turbo'

if (customElements.get("turbo-cable-stream-source") === void 0) {
  // Throw error for duplicate customElements, if the parent app also import @hotwired/turbo-rails
  // So we only need to import this if its nor imported previously 
  require('@hotwired/turbo-rails')
}
